import { motion } from 'framer-motion';
import styled from 'styled-components';
import dataAt from '../utilities/data-at.js';

const SCALE = { scale: 0.9 };
const BurgerEffect = ({ dataAt: someDataAt, className, children, onClick }) => (
	<motion.button whileTap={SCALE} data-at={someDataAt} className={className} onClick={onClick}>
		{children}
	</motion.button>
);

export default styled(BurgerEffect).attrs(dataAt);
